import r from "./index240.js";
import { createElementBlock as n, openBlock as a, createElementVNode as e } from "vue";
import i from "./index231.js";
const s = ["height", "width", "data-component"], d = ["stroke"];
function p(t, o, f, m, l, u) {
  return a(), n("svg", {
    height: t.finalSize,
    width: t.finalSize,
    viewBox: "0 0 28 28",
    "data-component": t.$options.name
  }, [
    e("path", {
      d: "M4,14a10,10 0 1,0 20,0a10,10 0 1,0 -20,0",
      fill: "transparent",
      "stroke-width": "2px",
      stroke: t.circleColor
    }, null, 8, d),
    o[0] || (o[0] = e("path", {
      d: "M4,14a10,10 0 1,0 20,0a10,10 0 1,0 -20,0",
      fill: "transparent",
      "stroke-width": "2px",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-dasharray": "100",
      "stroke-dashoffset": "100",
      "transform-origin": "center"
    }, [
      e("animate", {
        attributeName: "stroke-dashoffset",
        values: "99; 80; 50; 80; 99;",
        dur: "3s",
        repeatCount: "indefinite"
      }),
      e("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0",
        to: "360",
        dur: "1s",
        repeatCount: "indefinite"
      })
    ], -1))
  ], 8, s);
}
const _ = /* @__PURE__ */ i(r, [["render", p]]);
export {
  _ as default
};
